'use strict';
import angular from 'angular';

angular.module('currentUser.services', []);
angular.module('currentUser', ['currentUser.services']);